import { useTranslation } from 'react-i18next';
import { InquiryStatusChipClasses, InquiryStatusLabels } from '../../models/common/InquiryEnums';
import styles from './InquiryChips.module.scss';

interface InquiryStatusChipProps {
  status: string;
  closedReason?: string | null;
}

export default function InquiryStatusChip({ status, closedReason }: InquiryStatusChipProps) {
  const { t } = useTranslation();

  /*
   * A class rather than an inline hex. The colours were raw Material values mixed at 20% alpha
   * in a style attribute, which is why they matched nothing else on the screen; as classes they
   * are the site's own tokens and follow the theme. See InquiryStatusChipClasses for the scheme.
   */
  const statusClass = styles[InquiryStatusChipClasses[status]] ?? styles.statusClosed;

  const labelKey = closedReason === 'AutoClose'
    ? 'inquiries.status.closedAuto'
    : InquiryStatusLabels[status] || status;

  return (
    <span className={`${styles.statusChip} ${statusClass}`}>
      {t(labelKey)}
    </span>
  );
}
